'use client';

import { useEffect, useState } from 'react';
import { IconHub, IconProps } from './icons';

interface PromotionBannerProps {
  endTimeStr: string | null;
  title?: string;
  icon: IconProps['icon'];
}

export default function PromotionBanner({
  endTimeStr,
  title,
  icon,
}: PromotionBannerProps) {
  const [timeLeft, setTimeLeft] = useState<string | null>(null);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (!endTimeStr) {
      const timer = window.setTimeout(() => setIsVisible(false), 0);
      return () => window.clearTimeout(timer);
    }

    // 解析结束时间
    const endTime = new Date(endTimeStr).getTime();

    // 更新倒计时的函数
    const updateCountdown = () => {
      const now = new Date().getTime();
      const difference = endTime - now;

      // 如果时间已过，隐藏组件
      if (difference <= 0) {
        setIsVisible(false);
        return;
      }

      // 计算天、小时、分钟、秒
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      // 格式化时间显示
      setTimeLeft(`${days}天 ${hours}小时 ${minutes}分钟 ${seconds}秒`);
    };

    const initialTimer = window.setTimeout(updateCountdown, 0);
    const timer = setInterval(updateCountdown, 1000);

    return () => {
      window.clearTimeout(initialTimer);
      clearInterval(timer);
    };
  }, [endTimeStr]);

  // 如果不可见，不渲染组件
  if (!isVisible) {
    return null;
  }

  return (
    <div className="bg-linear-to-r from-primary to-primary/70 text-white py-3 px-4 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage:
            'url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nNjAnIGhlaWdodD0nNjAnIHZpZXdCb3g9JzAgMCA2MCA2MCcgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48ZyBmaWxsPSdub25lJyBmaWxsUnVsZT0nZXZlbm9kZCc+PGcgZmlsbD0nI2ZmZmZmZicgZmlsbE9wYWNpdHk9JzAuMDUnPjxjaXJjbGUgY3g9JzMwJyBjeT0nMzAnIHI9JzInLz48L2c+PC9nPjwvc3ZnPg==)',
        }}
      ></div>
      <div className="container mx-auto w-full relative">
        <div className="flex items-center justify-center gap-3 text-center">
          <div className="flex flex-col md:flex-row items-center gap-2">
            <div className="bg-white/20 backdrop-blur-xs px-2 py-1 rounded-full flex items-center gap-x-1 font-medium">
              <IconHub icon={icon} className="w-4 h-4" />
              <span className="text-xs">{timeLeft || '即将结束'}</span>
            </div>
            <span className="text-xl font-medium text-center">{title}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
